"use client";
import {useKeenSlider} from "keen-slider/react";
import {getAssetUrl} from "@/lib/helpers/getAssetUrl";

export default function Brands({sponsors}){
    const [sliderRef] = useKeenSlider({
        slides: {
            perView : "auto",
            spacing : 15
        }
    });
    return(
        <section className={"min-w-full py-5 bg-gradient-to-b  from-[#F7CE79] to-white "}>

            <div ref={sliderRef} className={"keen-slider flex items-center justify-center pt-3"}>
                {sponsors.map(function (sponsor) {
                    return (
                        <div key={sponsor} className={"keen-slider__slide flex flex-col items-center "}>
                            <a href={sponsor.url} rel={"noreferrer"} target={"_blank"}>
                                <img src={getAssetUrl(sponsor.image)} alt={sponsor.name} className={"w-64"}/>
                            </a>

                        </div>
                    )
                })}

            </div>
        </section>
    )
}